import { styled, Box, alpha } from '../../../base-components';

export const StyledDropZone = styled(Box)(({ theme }) => ({
    outline: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create(['opacity', 'padding']),
    '&:hover': {
        opacity: 0.72,
    },
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    width: '100%',
    minHeight: 200,
    maxHeight: 400,
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.neutral,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const ImagePreview = styled('img')({
    maxWidth: '100%',
    maxHeight: '400px',
    objectFit: 'contain',
    display: 'block',
});

export const ActionButtons = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    zIndex: 2,
}));

export const ActionButton = styled(Box)(({ theme }) => ({
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: alpha(theme.palette.background.paper, 0.9),
    cursor: 'pointer',
    transition: theme.transitions.create(['background-color', 'transform']),
    '&:hover': {
        backgroundColor: theme.palette.background.paper,
        transform: 'scale(1.1)',
    },
}));

export const PDFPreview = styled(Box)(({ theme }) => ({
    width: '100%',
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.neutral,
}));

export const FileInfo = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
}));
